module.exports = __webpack_public_path__ + "img/empty.6cacf133.jpeg";